import api from "../../services/api"
import encryptClass from "./encrypt.class"
import { dateDiff } from "../Fx/dateDiff"
import { resolveUnidadeIds } from "../grupoUnidades"

export default class schedule {
  constructor() {
    this.schedule = JSON.parse(window.sessionStorage.getItem("schedule"))
  }

  // Retorna uma lista de profissionais (médicos) por unidade, filtrando pela unidade
  // selecionada. `unidadeKey` pode ser um ID único ("10") ou um grupo ("NOVA_IGUACU"):
  // em ambos os casos resolvemos para os IDs reais e juntamos. Como o map é indexado
  // por profissional_id, médicos que atendem em mais de um prédio são deduplicados.
  getMedicByUnit(unidadeKey) {
    const ids = resolveUnidadeIds(unidadeKey)
    var data = {}
    Object.keys(this.schedule).forEach((index) => {
      var curScdl = this.schedule[index]
      if (ids.includes(curScdl.unidade_id)) {
        data[curScdl.profissional_id] = curScdl.profissional_name
      }
    })
    return data
  }

  // Retorna as datas disponíveis para um médico na unidade/grupo selecionado.
  // Cada data agrupa uma lista de slots; cada slot carrega seu próprio localId e
  // unidade_id (o prédio/andar real daquele horário). Num grupo, a mesma data pode
  // ter slots em prédios diferentes — por isso é uma lista, não um único localId.
  getDatesByMedicAndUnity(MedicId, unidadeKey) {
    const ids = resolveUnidadeIds(unidadeKey)
    var data = {}
    Object.keys(this.schedule).forEach((index) => {
      var curScdl = this.schedule[index]
      if (
        curScdl.profissional_id === parseInt(MedicId) &&
        ids.includes(curScdl.unidade_id)
      ) {
        if (curScdl.horarios.length > 0) {
          if (!data[curScdl.data]) data[curScdl.data] = { slots: [] }
          data[curScdl.data].slots.push({
            horarios: curScdl.horarios,
            localId: curScdl.local_id,
            unidadeId: curScdl.unidade_id,
          })
        }
      }
    })
    return data
  }

  // Retorna todas as datas disponíveis na unidade/grupo, filtrando pelos médicos
  // salvos em 'filter_medicos'. Usado só para popular o calendário (Object.keys),
  // então mantém uma entrada por data — a colisão de prédios é irrelevante aqui.
  getAllDates(unidadeKey) {
    const ids = resolveUnidadeIds(unidadeKey)
    var data = {}
    const filter = sessionStorage.getItem("filter_medicos").split(",").map(item => +item)

    Object.keys(this.schedule).forEach((index) => {
      var curScdl = this.schedule[index]

      if (ids.includes(curScdl.unidade_id)) {
        if (
          Object.keys(curScdl.horarios).length > 0 &&
          filter.includes(curScdl.profissional_id)
        ) {
          data[curScdl.data] = {
            horarios: curScdl.horarios,
            localId: curScdl.local_id,
          }
        }
      }
    })
    return data
  }

  // Retorna os médicos disponíveis numa data e unidade/grupo. Cada médico carrega uma
  // lista de slots (horarios + localId + unidade_id); num grupo o mesmo médico pode
  // atender em prédios diferentes na mesma data, então cada slot é preservado.
  async getMedicsByDate(date, unidadeKey, convenio) {
    let patientFound = sessionStorage.getItem("patientFound")
    patientFound = JSON.parse(encryptClass.reveal(patientFound))

    if (convenio && convenio.includes("::")) {
      convenio = parseInt(convenio.split("::")[1])
    }

    const ids = resolveUnidadeIds(unidadeKey)
    var result = {}

    Object.keys(this.schedule).forEach((index) => {
      var curScdl = this.schedule[index]
      if (curScdl.data === date && ids.includes(curScdl.unidade_id)) {
        if (
          curScdl.horarios.length > 0
        ) {
          if (!result[curScdl.profissional_id]) {
            result[curScdl.profissional_id] = { slots: [] }
          }
          result[curScdl.profissional_id].slots.push({
            horarios: curScdl.horarios,
            localId: curScdl.local_id,
            unidadeId: curScdl.unidade_id,
          })
        }
      }
    })
    return result
  }

  // Retorna o nome do médico baseado no seu ID, buscando em um repositório salvo no sessionStorage
  getMedicById(ID) {
    let medicRepository = sessionStorage.getItem("professionals")
    medicRepository = medicRepository ? JSON.parse(medicRepository) : false

    let newMedicRepository = []

    if (medicRepository) {
      Object.keys(medicRepository).forEach((index) => {
        newMedicRepository[medicRepository[index]] = index
      })
      return newMedicRepository[ID]
    } else {
      return false
    }
  }

  // Filtra os profissionais com base em restrições de idade e convênio, Retorna true se o profissional cumpre os requisitos, caso contrário, retorna false
  filter(id, convenio, professionals_limits, idade) {
    const limit = professionals_limits.find(
      (item) => item.profissional_id == parseInt(id)
    )

    if (limit) {
      const idade_minima = limit.idade_minima && limit.idade_minima > idade
      const idade_maxima = limit.idade_maxima && limit.idade_maxima < idade

      const convenioHabilitado =
        convenio == null || isNaN(convenio)
          ? false
          : !limit.convenios.includes(convenio)

      return !(idade_minima || idade_maxima || convenioHabilitado)
    }
  }
}
